import {
  Box,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { IEmptyStateCardProps } from "../Utils/Types";
import styles from "../Styles/emptyStateCard.module.css";

/**
 * Reusable EmptyStateCard component for displaying empty states
 * Features:
 * - Customizable icon
 * - Title and subtitle text
 * - Consistent styling with hover effects
 * - Responsive design
 */
export default function EmptyStateCard({
  icon,
  title,
  subtitle,
  className
}: IEmptyStateCardProps) {

  return (
    <Card className={`${styles.emptyStateCard} ${className || ''}`}>
      <CardContent className={styles.emptyStateContent}>
        {icon && (
          <Box className={styles.emptyStateIcon}>
            {icon}
          </Box>
        )}
        
        <Typography variant="h6" className={styles.emptyStateTitle}>
          {title}
        </Typography>
        
        {subtitle && (
          <Typography variant="body2" className={styles.emptyStateSubtitle}>
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}